'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useState } from 'react';
import { TutorialChatContext, type TutorialChatMessage } from '@/contexts/tutorial-chat-context';
export const TutorialChatProvider = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [messages, setMessages] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (chatId, message) => {
      setMessages(prev => ({
        ...prev,
        [chatId]: [...(prev[chatId] || []), message]
      }));
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const addMessage = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = chatId_0 => {
      setMessages(prev_0 => ({
        ...prev_0,
        [chatId_0]: []
      }));
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const resetChat = t3;
  let t4;
  if ($[3] !== messages) {
    t4 = {
      messages,
      addMessage,
      resetChat
    };
    $[3] = messages;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <TutorialChatContext.Provider value={t4}>{children}</TutorialChatContext.Provider>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};